module.exports = __webpack_public_path__ + "static/media/uranus2.48249b3c.png";